export default function getData(_ref) {
  let {
    crumbs = [],
    baseUrl = ''
  } = _ref;
  const itemListElement = crumbs.map((_ref2, i) => {
    let {
      name,
      value
    } = _ref2;
    return {
      '@type': 'ListItem',
      position: i + 1,
      item: {
        '@id': `${baseUrl}${value}`,
        name
      }
    };
  });
  return {
    '@context': 'http://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement
  };
}